import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 
  
  .generated-images-holder-var6 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var6 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .text-var6 {
    position: absolute;
    width: 100%;
    top: 0;
    font-size: 55px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    letter-spacing: -0.05px;
    background-color: white;
    p {
      display: inline-block;
      margin: 0;
      padding: 26px 5px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
    &--multiple-lines {
    font-size: 45px;
      p {
        padding: 27px 10px;
      }
    }
  }
  .full-image-var6 {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .actual-photo-var6 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var6--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
